/**
 * converte as surveys (estrutura de dados da store)
 * para uma estrutura de dados que será interpretada
 * pelo componente de seção.
 *
 * @param {*} surveys
 */
function adaptSurveysToData(surveys, selectedIds) {
  const surveysData = surveys.map((survey) => ({
    value: survey.id,
    label: survey.titulo,
    checked: selectedIds ? selectedIds.includes(survey.id) : false,
  }));
  return surveysData;
}

export { adaptSurveysToData };
